<template>
  <!-- 患者情報編集 -->
  <div id="AppPatientManagementEditPatient">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div style="margin-left: 50px; margin-right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">患者情報編集</label>
        </div>
      </div>
      <!-- 詳細表示 -->
      <div style="detailArea">
        <div>
          <table class="table is-full" v-bind:key="renderKey">
            <table style="width: 100%;">
              <tr>
                <th style="border-bottom: solid 1px; width: 150px;">患者コード</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  <span>{{data.code}}</span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">患者名（患者名カナ）</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  <span>{{data.name}}<template v-if="data.kana">（{{data.kana}}）</template></span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">住所</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  <span>〒{{data.zipCode}} {{data.address}}</span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">電話</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  <span>{{data.phone}}</span>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">携帯電話</th>
                <td style="border-bottom: solid 1px;" colspan="6">{{ data.mobile }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">緊急連絡先</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  <b-field
                    :type="{'is-danger':errors.has('emergencyContact')}"
                    :message="errors.first('emergencyContact')"
                  >
                    <b-input
                      v-model="data.emergencyContact "
                      name="emergencyContact"
                      data-vv-as="緊急連絡先"
                      v-validate="'max:16'"
                    ></b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">勤務先名</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  <b-field
                    :type="{'is-danger':errors.has('employment')}"
                    :message="errors.first('employment')"
                  >
                    <b-input
                      v-model="data.employment"
                      name="employment"
                      data-vv-as="勤務先名"
                      v-validate="'max:35'"
                      maxlength="35"
                    ></b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">勤務連絡先</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  <b-field
                    :type="{'is-danger':errors.has('employmentContact')}"
                    :message="errors.first('employmentContact')"
                  >
                    <b-input
                      v-model="data.employmentContact"
                      name="employmentContact"
                      data-vv-as="勤務連絡先"
                      v-validate="'max:16'"
                    ></b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">誕生日</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  <template>
                    <section>
                      <b-field>
                        <b-datepicker
                          v-model="birthday"
                          type="day"
                          placeholder="誕生日"
                          icon="calendar-today"
                          :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                          :day-names="['日','月','火','水','木','金','土']"
                        ></b-datepicker>
                      </b-field>
                    </section>
                  </template>
                </td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">年齢</th>
                <td style="border-bottom: solid 1px;" colspan="6">{{ data.age }}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">性別</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  <b-field
                    :type="{'is-danger':errors.has('gender')}"
                    :message="errors.first('gender')"
                  >
                    <b-select
                      v-model="data.gender"
                      expanded
                      name="gender"
                      data-vv-as="性別"
                      v-validate="'gender'"
                    >
                      <option value="M">男性</option>
                      <option value="F">女性</option>
                    </b-select>
                  </b-field>
                </td>
              </tr>
              <template>
                <tr>
                  <th style="border-bottom: solid 1px;">緊急連絡レベル</th>
                  <td style="border-bottom: solid 1px;" colspan="6">
                    <b-field
                      :type="{'is-danger':errors.has('anpyLevel')}"
                      :message="errors.first('anpyLevel')"
                    >
                      <b-select
                        expanded
                        v-model="data.anpyLevel"
                        name="anpyLevel"
                        data-vv-as="緊急連絡レベル"
                        data-vv-validate-on="input"
                      >
                        <option value="" :disabled="userInfo.roleId != 1"></option>
                        <option value="1" :disabled="userInfo.roleId != 1">S : NPPV 24h（マスク）</option>
                        <option value="2" :disabled="userInfo.roleId != 1">A : TPPV 24h（気切）</option>
                        <option value="3" :disabled="userInfo.roleId != 1">B : TPPV 夜間のみ（気切）</option>
                        <option value="4" :disabled="userInfo.roleId != 1">C : NPPV 夜間のみ（マスク）</option>
                        <option value="5" :disabled="userInfo.roleId != 1">D：HOT24h（設定値３L以上）</option>
                        <option value="6" :disabled="userInfo.roleId != 1">E：HOT24h（設定値３L未満）</option>
                      </b-select>
                    </b-field>
                  </td>
                </tr>
                <tr v-for="(item, index) in data.tels" v-bind:key="index">
                  <th
                    style="border-bottom: solid 1px; border-top: solid 1px;"
                    rowspan="10"
                    v-if="index==0"
                  >
                    緊急連絡先
                    <b-button
                      style="float:right; margin-left:10px;"
                      class="button is-primary has-text-centered"
                      icon-left="account-plus"
                      native-type="button"
                      v-on:click="addTels()"
                      v-if="userInfo.roleId == 1"
                    ></b-button>
                  </th>
                  <td style="border-bottom: solid 1px; border-top: solid 1px;">
                    <b-field
                      :type="{'is-danger':errors.has(getFieldName('emergencyContactlList',index))}"
                      :message="errors.first(getFieldName('emergencyContactlList',index))"
                    >
                      <b-select
                        v-model="item.emergencyContactlList"
                        :name="getFieldName('emergencyContactlList',index)"
                        :input="inputValue(item.emergencyContactlList,index)"
                        data-vv-as="続柄"
                        data-vv-validate-on="input"
                        v-validate="`${item.emergencyContactPhoneNumber|item.selfArrow!=null&item.selfArrow!=''?'required':''}`"
                      >
                        <option value :disabled="userInfo.roleId != 1"></option>
                        <option value="本人" :disabled="userInfo.roleId != 1">本人</option>
                        <option value="家族" :disabled="userInfo.roleId != 1">家族</option>
                        <option value="知人" :disabled="userInfo.roleId != 1">知人</option>
                        <option value="訪問看護" :disabled="userInfo.roleId != 1">訪問看護</option>
                        <option value="医師" :disabled="userInfo.roleId != 1">医師</option>
                        <option value="ME" :disabled="userInfo.roleId != 1">ME</option>
                        <option value="その他" :disabled="userInfo.roleId != 1">その他</option>
                      </b-select>
                    </b-field>
                  </td>
                  <td style="border-bottom: solid 1px; border-top: solid 1px;">
                    <b-field
                      :type="{'is-danger':errors.has(getFieldName('emergencyContactFree',index))}"
                      :message="errors.first(getFieldName('emergencyContactFree',index))"
                    >
                      <b-input
                        v-model="item.emergencyContactFree"
                        :name="getFieldName('emergencyContactFree',index)"
                        data-vv-as="続柄(フリー)"
                        placeholder="「続柄：その他」選択時のフリー項目"
                        data-vv-validate-on="input"
                        v-validate="`${item.emergencyContactlList=='その他'?'required':''}|max:20`"
                        :readonly="userInfo.roleId != 1 || item.emergencyContactlList!='その他'"
                      ></b-input>
                    </b-field>
                  </td>
                  <td style="border-bottom: solid 1px; border-top: solid 1px;">
                    <b-field
                      :type="{'is-danger':errors.has(getFieldName('emergencyContactPhoneNumber',index))}"
                      :message="errors.first(getFieldName('emergencyContactPhoneNumber',index))"
                    >
                      <b-input
                        v-model="item.emergencyContactPhoneNumber"
                        :name="getFieldName('emergencyContactPhoneNumber',index)"
                        data-vv-as="緊急連絡先"
                        placeholder="携帯番号"
                        :readonly="userInfo.roleId!=1"
                        data-vv-validate-on="input"
                        v-validate="`${item.emergencyContactlList!=null&item.emergencyContactlList!=''|item.selfArrow!=null&item.selfArrow!=''?'required':''}|max:20`"
                      ></b-input>
                    </b-field>
                  </td>
                  <th
                    style="border-bottom: solid 1px; border-top: solid 1px; width:150px;"
                  >停電情報の配信希望</th>
                  <td style="border-bottom: solid 1px; border-top: solid 1px;">
                    <b-field
                      :type="{'is-danger':errors.has(getFieldName('selfArrow',index))}"
                      :message="errors.first(getFieldName('selfArrow',index))"
                    >
                      <b-select
                        v-model="item.selfArrow"
                        :name="getFieldName('selfArrow',index)"
                        data-vv-as="連絡可否"
                        data-vv-validate-on="input"
                        v-validate="`${item.emergencyContactPhoneNumber|item.emergencyContactlList!=null&item.emergencyContactlList!=''?'required':''}`"
                      >
                        <option value :disabled="userInfo.roleId != 1"></option>
                        <option value="0" :disabled="userInfo.roleId != 1">希望</option>
                        <option value="1" :disabled="userInfo.roleId != 1">希望しない</option>
                      </b-select>
                    </b-field>
                  </td>
                  <td style="border-bottom: solid 1px; border-top: solid 1px;">
                    <b-button
                      v-if="index > 4 && userInfo.roleId == 1"
                      style="float:right; margin-left:10px;"
                      class="button is-primary has-text-centered"
                      icon-left="account-minus"
                      native-type="button"
                      v-on:click="removeTels(index)"
                    ></b-button>
                  </td>
                </tr>
                <tr>
                  <th style="border-bottom: solid 1px;">Philips関係者</th>
                  <td style="border-bottom: solid 1px;" colspan="6">
                    <b-field
                      :type="{'is-danger':errors.has('anpyPhilps1')}"
                      :message="errors.first('anpyPhilps1')"
                    >
                      <b-input
                        type="email"
                        v-model="data.anpyPhilps1"
                        name="anpyPhilps1"
                        data-vv-as="Philips関係者連絡先1"
                        v-validate="'email|max:256'"
                        :readonly="userInfo.roleId != 1"
                      ></b-input>
                    </b-field>
                    <b-field
                      :type="{'is-danger':errors.has('anpyPhilps2')}"
                      :message="errors.first('anpyPhilps2')"
                    >
                      <b-input
                        type="email"
                        v-model="data.anpyPhilps2"
                        name="anpyPhilps2"
                        data-vv-as="Philips関係者連絡先2"
                        v-validate="'email|max:256'"
                        :readonly="userInfo.roleId != 1"
                      ></b-input>
                    </b-field>
                    <b-field
                      :type="{'is-danger':errors.has('anpyPhilps3')}"
                      :message="errors.first('anpyPhilps3')"
                    >
                      <b-input
                        type="email"
                        v-model="data.anpyPhilps3"
                        name="anpyPhilps3"
                        data-vv-as="Philips関係者連絡先3"
                        v-validate="'email|max:256'"
                        :readonly="userInfo.roleId != 1"
                      ></b-input>
                    </b-field>
                  </td>
                </tr>
              </template>
              <tr>
                <th style="border-bottom: solid 1px;">メモ</th>
                <td style="border-bottom: solid 1px;" colspan="6">
                  <b-field :type="{'is-danger':errors.has('note')}" :message="errors.first('note')">
                    <b-input
                      type="textarea"
                      v-model="data.note"
                      name="note"
                      data-vv-as="メモ"
                      v-validate="'max:512'"
                      maxlength="512"
                    ></b-input>
                  </b-field>
                </td>
              </tr>

              <tr>
                <td style="border-bottom: solid 1px;" colspan="7">
                  <file-chooser v-model="data.files" @download-file="downloadFile($event)"></file-chooser>
                </td>
              </tr>
            </table>
          </table>
        </div>
      </div>
    </div>
    <!-- 下部余白 -->
    <div style="height: 50px;" />
    <div class="columns">
      <div class="column is-full" style="text-align:center;">
        <b-button
          v-on:click="back"
          class="button"
          type="is-primary"
          icon-left="keyboard-backspace"
          native-type="button"
        >戻る</b-button>
        <b-button
          v-on:click="save"
          class="button"
          type="is-primary"
          icon-left="content-save"
          native-type="button"
        >登録</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import FileChooser from "./common/FileChooser.vue";

export default {
  name: "AppPatientManagementEditPatient",
  methods: {
    addTels: function() {
      // ANPY緊急連絡先追加(最大10)
      if (this.data.tels.length < 10) {
        this.data.tels.push({});
        // 再レンダリングの為、フラグ切替
        this.renderKey = this.renderKey == true ? false : true;
      } else {
        this.showErrorMessage("連絡先は10件までしか登録できません。");
      }
    },
    removeTels: function(index) {
      this.data.tels.splice(index, 1);
      // 再レンダリングの為、フラグ切替
      this.renderKey = this.renderKey == true ? false : true;
    },
    save: function(event) {
      this.$validator.validateAll().then(async result => {
        // 添付ファイル情報設定
        if (this.data.files.length) {
          let files = JSON.parse(JSON.stringify(this.data.files));
          for (const file of files) {
            delete file.file;
          }
          this.uploadFiles = files;

          // 添付ファイルアップロード
          try {
            this.s3UploadData = await this.multipleUpload(this.data.files, this.$store.state.subSystem, this.showErrorMessage);
          } catch (error) {
            // エラーコールバックで処理済み
            return;
          }
        }

        if (result) {
          var excuteApi = this.setPatientInfoPOST;
          var successCallBack = this.setPatientInfoSuccess;
          var errorCallBack = this.setPatientInfoError;
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        } else {
          scrollTo(0, 0);
        }
      });
    },
    setPatientInfoPOST: async function(client) {
      var setData = {
        code: this.data.code ? this.data.code : "",
        kana: this.data.kana,
        emergencyContact: this.data.emergencyContact
          ? this.data.emergencyContact
          : "",
        employment: this.data.employment ? this.data.employment : "",
        employmentContact: this.data.employmentContact
          ? this.data.employmentContact
          : "",
        birthday: this.data.birthday ? this.data.birthday : "",
        gender: this.data.gender ? this.data.gender : "",
        anpyLevel: this.data.anpyLevel ? this.data.anpyLevel : "",
        anpyPhilps1: this.data.anpyPhilps1 ? this.data.anpyPhilps1 : "",
        anpyPhilps2: this.data.anpyPhilps2 ? this.data.anpyPhilps2 : "",
        anpyPhilps3: this.data.anpyPhilps3 ? this.data.anpyPhilps3 : "",
        note: this.data.note ? this.data.note : "",
        files: this.uploadFiles,
      };
      // ANPY緊急連絡先の設定
      var cnt = 1;
      for (var i = 0; i < this.data.tels.length; i++) {
        if (
          this.data.tels[i].emergencyContactlList != null &&
          this.data.tels[i].emergencyContactlList != ""
        ) {
          var relationship = "relationship" + String(cnt);
          var relationshipFree = "relationshipFree" + String(cnt);
          var relationshipPhoneNumber = "relationshipPhoneNumber" + String(cnt);
          var relationshipCallFlag = "relationshipCallFlag" + String(cnt);
          setData[relationship] = this.data.tels[i].emergencyContactlList;
          setData[relationshipFree] = this.data.tels[i].emergencyContactFree
            ? this.data.tels[i].emergencyContactFree
            : "";
          setData[relationshipPhoneNumber] = this.data.tels[
            i
          ].emergencyContactPhoneNumber;
          setData[relationshipCallFlag] =
            this.data.tels[i].selfArrow == "0" ? true : false;
          cnt = cnt + 1;
        }
      }
      if (cnt != 11) {
        for (cnt; cnt != 11; cnt++) {
          var relationship = "relationship" + String(cnt);
          var relationshipFree = "relationshipFree" + String(cnt);
          var relationshipPhoneNumber = "relationshipPhoneNumber" + String(cnt);
          var relationshipCallFlag = "relationshipCallFlag" + String(cnt);
          setData[relationship] = null;
          setData[relationshipFree] = null;
          setData[relationshipPhoneNumber] = null;
          setData[relationshipCallFlag] = null;
        }
      }

      if (this.s3UploadData && this.s3UploadData.identifier) {
        setData.s3UploadData = this.s3UploadData;
      }

      return client.apis.apiPatient.setPatientInfoPOST({
        body: setData
      });
    },
    setPatientInfoSuccess: function(result) {
      var excuteApi = this.getPatientInfoPOST;
      var successCallBack = this.getPatientInfoPOSTSuccess;
      var errorCallBack = this.getPatientInfoPOSTError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
      this.showSuccess(result);
    },
    setPatientInfoError: function(result) {
      this.showErrorMessage(result);
    },

    getPatientInfoPOST: function(client) {
      var body = this.searchConditions;
      return client.apis.apiPatient.getPatientInfoPOST({
        body: {
          code: this.code
        }
      });
    },
    getPatientInfoPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = JSON.parse(JSON.stringify(result.obj));
      // ANPY緊急連絡先の整形
      this.data["tels"] = [];
      for (var i = 1; i < 11; i++) {
        var relationship = "relationship" + String(i);
        var relationshipFree = "relationshipFree" + String(i);
        var relationshipPhoneNumber = "relationshipPhoneNumber" + String(i);
        var relationshipCallFlag = "relationshipCallFlag" + String(i);
        if (this.data[relationship] && this.data[relationship].length > 0) {
          this.data.tels.push({
            emergencyContactlList: this.data[relationship],
            emergencyContactFree: this.data[relationshipFree],
            emergencyContactPhoneNumber: this.data[relationshipPhoneNumber],
            selfArrow: this.data[relationshipCallFlag] ? "0" : "1"
          });
        }
      }

      if (this.data.tels.length < 5) {
        var cnt = 5 - this.data.tels.length;
        for (var j = 0; j < cnt; j++) {
          this.data.tels.push({
            emergencyContactlList: "",
            emergencyContactFree: "",
            emergencyContactPhoneNumber: "",
            selfArrow: null
          });
        }
      }
      if (this.data.birthday.indexOf("/") == -1) {
        // 「/」なしの文字列処理
        if (!isNaN(Number(this.data.birthday))) {
          var regix = /^([0][1-9]{1}|[1][012]{1})/;
          var year = this.data.birthday.slice(0, 4) + "/";

          var monthDay = this.data.birthday.slice(4);
          var searchMonth = regix.exec(monthDay);
          var month = searchMonth[0] + "/";

          var day = monthDay.slice(searchMonth[0].length);

          var birth = year + month + day;
          this.birthday = this.parseDate(birth);
        }
      } else {
        this.birthday = this.parseDate(this.data.birthday);
      }
      // 器械交換キャンセル用初期データ
      const init = JSON.parse(JSON.stringify(this.data));
      this.initData = JSON.parse(JSON.stringify(init));
    },
    getPatientInfoPOSTError: function(result) {
      this.showErrorMessage(result);
    },
    back: function(event) {
      this.$router.push({
        name: "AppPatientManagement",
        params: { searchConditions: this.searchConditions }
      });
    },
    getFieldName: function(str, index) {
      return str + index;
    },
    inputValue: function(value, index) {
      if (value != "その他") {
        this.data.tels[index].emergencyContactFree = "";
      }
    },

    downloadFile: function(file) {
      this.targetFile = file;
      this.downloadS3ApiCall(this.getPatientFile, this.showErrorMessage);
      return;
    },

    getPatientFile: function(client) {
      const res = client.apis.apiPatient.getPatientFileGET({
        id: this.targetFile.id,
      }); 
      this.targetFile = null;
      return res;
    },
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var data = {
      recipientCode: "",
      recipientName: "",
      recipientNameKana: "",
      recipientNameMemo: "",
      tels: [],
      staffId: "",
      staffName: "",
      salesOfficeCode: "",
      officeName: "",
      itemCode: "",
      serial: "",
      butterryItemCode: "",
      butterrySerial: "",
      signature: "",
      alternativeWriting: null,
      alternativeWritingReason: "",
      machineReplaceProductCode: "",
      machineReplaceSerialNumber: "",
      emergencyLevel: "",
      files: [],
    };
    var code = this.$route.params.code;
    var searchConditions = this.$route.params["searchConditions"];
    var birthday;
    return {
      data,
      birthday,
      code,
      searchConditions,
      renderKey: true,
      userInfo,
      targetFile: null,
      uploadFiles: [],
      s3UploadData: null,
    };
  },
  filters: {},
  components: {
    "file-chooser": FileChooser,
  },
  mounted: function() {
    var excuteApi = this.getPatientInfoPOST;
    var successCallBack = this.getPatientInfoPOSTSuccess;
    var errorCallBack = this.getPatientInfoPOSTError;
    // WebAPI Call
    this.apiCall(excuteApi, successCallBack, errorCallBack);
  },
  watch: {
    birthday(value) {
      this.data.birthday = this.formatDate(value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AppPatientManagementEditPatient.vue